var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.176483 6.35289C0.176483 4.11126 1.99368 2.29407 4.23531 2.29407H19.7647C22.0063 2.29407 23.8235 4.11127 23.8235 6.35289V19.7647C23.8235 22.0063 22.0063 23.8235 19.7647 23.8235H4.23531C1.99368 23.8235 0.176483 22.0063 0.176483 19.7647V6.35289ZM4.23531 3.35289C2.57845 3.35289 1.23531 4.69604 1.23531 6.35289V19.7647C1.23531 21.4215 2.57845 22.7647 4.23531 22.7647H19.7647C21.4216 22.7647 22.7647 21.4215 22.7647 19.7647V6.35289C22.7647 4.69604 21.4216 3.35289 19.7647 3.35289H4.23531Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6471 0.176514C17.9394 0.176514 18.1765 0.413539 18.1765 0.705925V4.94122C18.1765 5.23361 17.9394 5.47063 17.6471 5.47063C17.3547 5.47063 17.1176 5.23361 17.1176 4.94122V0.705925C17.1176 0.413539 17.3547 0.176514 17.6471 0.176514Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35293 0.176514C6.64531 0.176514 6.88234 0.413539 6.88234 0.705925V4.94122C6.88234 5.23361 6.64531 5.47063 6.35293 5.47063C6.06054 5.47063 5.82352 5.23361 5.82352 4.94122V0.705925C5.82352 0.413539 6.06054 0.176514 6.35293 0.176514Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.176483 9.17651C0.176483 8.88412 0.413509 8.64709 0.705895 8.64709H23.2941C23.5865 8.64709 23.8235 8.88412 23.8235 9.17651C23.8235 9.46889 23.5865 9.70592 23.2941 9.70592H0.705895C0.413509 9.70592 0.176483 9.46889 0.176483 9.17651Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.bd4a676e8534719ea0d8e22a4ddee7be.svg";
export { ForwardRef as ReactComponent };